<template>
    <BreadCrumb PageTitle="Envoyer une notification de campagne" />
    <AddNotificationCampagne />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddNotificationCampagne from "../../components/Notification/AddNotificationCampagne.vue";
  
    export default defineComponent({
      name: "AddNotificationCampagnePage",
      components: {
        BreadCrumb,
        AddNotificationCampagne,
      },
    });
  </script>